import { render } from "./PlaybookLanding.vue?vue&type=template&id=4467b2c6"
import script from "./PlaybookLanding.vue?vue&type=script&lang=js"
export * from "./PlaybookLanding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/PlaybookLanding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4467b2c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4467b2c6', __exports__)) {
    api.reload('4467b2c6', __exports__)
  }
  
  module.hot.accept("./PlaybookLanding.vue?vue&type=template&id=4467b2c6", () => {
    api.rerender('4467b2c6', render)
  })

}


export default __exports__